import { useEffect, useState } from 'react';

import { serviceLocalStorage } from '../utils/serviceLocalStorage';

export const useWebSocket = () => {
  const [data, setData] = useState();
  const [status, setStatus] = useState('');
  const [error, setError] = useState(null);
  const [socket, setSocket] = useState(null);

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const accessToken = serviceLocalStorage.getAccessToken();
  const initUrl = process.env.REACT_APP_WEBSOCKET_URL.replace(/ws?:/, protocol);

  useEffect(() => {
    if (accessToken && !socket) {
      try {
        setSocket(new WebSocket(initUrl + accessToken));
      } catch (error) {
        console.error('WebSocket creation error!', error);
      }
    } // eslint-disable-next-line
  }, [
    accessToken,
    initUrl,
  ]);

  if (socket) {
    socket.onopen = (e) => {
      setStatus(e.type);
    };
    socket.onmessage = (event) => {
      setData(JSON.parse(event.data));
    };
    socket.onerror = (error) => {
      setError(error);
    };
  }

  return { status, data, error };
};
